export default __webpack_public_path__ + "static/media/Monsoon-in-Pachmarhi.3cc764a8.jpg";